import React from 'react';
import ExpandedGrid from './ExpandedGrid';
import TruncateGrid from './TruncatedGrid';
const GalleryGrid = ({ className, items, truncate, onClick, children, itemKeyProp }) => {
    const Component = truncate || items.length <= 4 ? TruncateGrid : ExpandedGrid;
    return (React.createElement(Component, { className: className, items: items, itemKeyProp: itemKeyProp, onClick: onClick }, children));
};
export default GalleryGrid;
//# sourceMappingURL=index.js.map